'use strict'
/*global  process:true*/
/* global API_GATEWAY:true */
let apiUrl = API_GATEWAY?(API_GATEWAY+'/collect'):(process.env.HOST_NAME + '/collect')
let apiPath = '/v1/etl'
let apiPathV1 = '/v1'
let apiPathV2 = '/v2'


const config = {
  api: {
    // notification: `${apiUrl}${apiPath}/notification`,
    // scenes: `${apiUrl}${apiPath}/scenes`,
    // scenes_model: `${apiUrl}${apiPath}/scenes/model`,
    // scenes_scene_json: `${apiUrl}${apiPath}/scenes/scene_json`,
    jobs: `${apiUrl}${apiPath}/jobs`,
    history_jobs: `${apiUrl}${apiPath}/history-jobs`,
    data_sets: `${apiUrl}${apiPath}/data-sets`,
    options: `${apiUrl}${apiPath}/options`,
    job_procedure: `${apiUrl}${apiPath}/job-procedure`,
    // var: `${apiUrl}${apiPath}/var`,
    // job_target: `${apiUrl}${apiPath}/job/target`,
    // sign_url: `${apiUrl}${apiPath}/sign_url`,
    login: `${apiUrl}${apiPath.replace('/etl', '')}/login`,
    // qrcode: `${apiUrl}${apiPath}/qrcode`,
    // filters: `${apiUrl}${apiPath}/filters`,
    logout: `${apiUrl}${apiPath.replace('/etl', '')}/logout`,
    // codeinfo: `${apiUrl}${apiPath}/code_info`,
    // group: `${apiUrl}${apiPath}/jobs/group`,
    // data_sets: `${apiUrl}${apiPath}/job/data_sets`,
    // job_progress: `${apiUrl}${apiPath}/job/progress`,
    // job_user: `${apiUrl}${apiPath}/job/user`,
    // user_center:`${apiUrl}${apiPath}/user-center`,
    client_id:`${apiUrl}${apiPath}/client_id`,
    // task_result:`${apiUrl}${apiPath}/task/result`,
    // voice_conversions:`${apiUrl}${apiPath}/voice-conversions`,
    // scene_json_check:`${apiUrl}${apiPath}/scene-json/check`,
    // tools:`${apiUrl}${apiPath}/tools`,
    collection_categories: `${apiUrl}${apiPathV1}/categories`,
    collection_directions: `${apiUrl}${apiPathV1}/collection-directions`,
    data_sets_V2: `${apiUrl}${apiPathV2}/data-sets`,
  	filter_jobs: `${apiUrl}${apiPathV2}/jobs`,
  	filter_select:  `${apiUrl}${apiPathV2}/filters`,
  }
}

export default config



// WEBPACK FOOTER //
// ./src/js/utils/config.js